import {
  addDays,
  endOfISOWeek,
  endOfMonth,
  format,
  isAfter,
  isBefore,
  startOfDay,
  startOfISOWeek,
} from 'date-fns';
import { dbDayDateToken } from 'server/static/dbDayDateToken';

export class EmploymentAvailabilityWeek {
  public dates: string[] = [];
  public startDate: Date;
  public weekStartDate: Date;
  public weekEndDate: Date;
  public endDate: Date;

  private inputStartDate: Date;

  constructor(
    inputStartDate: Date,
    earlyEndDate?: Date,
    breakFrom?: Date,
    breakTo?: Date,
  ) {
    this.inputStartDate = inputStartDate;
    this.startDate = startOfDay(inputStartDate);
    this.weekStartDate = startOfISOWeek(inputStartDate);
    this.weekEndDate = endOfISOWeek(inputStartDate);

    const endOfWeekDate = startOfDay(endOfISOWeek(inputStartDate));
    const endOfMonthDate = startOfDay(endOfMonth(inputStartDate));

    if (isAfter(endOfWeekDate, endOfMonthDate)) {
      this.endDate = endOfMonthDate;
    } else {
      this.endDate = endOfWeekDate;
    }

    if (earlyEndDate && isBefore(earlyEndDate, this.endDate)) {
      this.endDate = earlyEndDate;
    }

    let currentDayStart = new Date(this.startDate);
    const endDate = addDays(this.endDate, 1);
    while (isBefore(currentDayStart, endDate)) {
      if (
        !breakFrom ||
        !breakTo ||
        isBefore(currentDayStart, breakFrom) ||
        isAfter(currentDayStart, breakTo)
      ) {
        this.dates.push(format(currentDayStart, dbDayDateToken));
      }
      currentDayStart = addDays(currentDayStart, 1);
    }
  }
}
